import {translations} from 'presentation/translations-new';
import {AddressUpdateModalContent, AddressUpdateModalMode} from './types';

enum AddressUpdateStatusEnum {
	OutDated = 0,
	InsufficientQualit = 1,
	DoenstHaveResidential = 2,
	Suggested = 3,
}

enum AddressValidationReasonEnum {
	DESATUALIZADO = 'DESATUALIZADO',
	QUALIDADE_INSUFICENTE = 'QUALIDADE_INSUFICENTE',
	SEM_ENDERECO_RESIDENCIA = 'SEM_ENDERECO_RESIDENCIA',
	SEM_CONFIRMACAO_BENEFICIARIO = 'SEM_CONFIRMACAO_BENEFICIARIO',
}

const addressStatusToModalMode: Record<AddressUpdateStatusEnum, AddressUpdateModalMode> = {
	[AddressUpdateStatusEnum.OutDated]: 'request',
	[AddressUpdateStatusEnum.InsufficientQualit]: 'request',
	[AddressUpdateStatusEnum.DoenstHaveResidential]: 'firstAccess',
	[AddressUpdateStatusEnum.Suggested]: 'suggestion',
};

const homeAddressUpdateModalContent = translations['pt-br'].privateFlow.home.addressUpdateModals;
const {yes, no} = translations['pt-br'].commons;

const homeAddressUpdateModalByMode: Record<AddressUpdateModalMode, AddressUpdateModalContent> = {
	confirmation: {
		headerTitle: homeAddressUpdateModalContent.confirmation.headerTitle,
		title: homeAddressUpdateModalContent.confirmation.title,
		description: homeAddressUpdateModalContent.request.description,
		variant: 'warning',
		primaryAction: homeAddressUpdateModalContent.confirmation.primaryAction,
		secondaryAction: homeAddressUpdateModalContent.confirmation.secondaryAction,
	},
	request: {
		headerTitle: homeAddressUpdateModalContent.request.headerTitle,
		title: homeAddressUpdateModalContent.request.title,
		description: homeAddressUpdateModalContent.request.description,
		variant: 'warning',
		primaryAction: homeAddressUpdateModalContent.request.primaryAction,
		secondaryAction: homeAddressUpdateModalContent.request.secondaryAction,
	},
	firstAccess: {
		headerTitle: homeAddressUpdateModalContent.firstAccessAddressFoundModal.title,
		title: homeAddressUpdateModalContent.firstAccessAddressFoundModal.message,
		description: homeAddressUpdateModalContent.firstAccessAddressFoundModal.description,
		variant: 'info',
		primaryAction: yes,
		secondaryAction: no,
	},
	suggestion: {
		headerTitle: homeAddressUpdateModalContent.addressSuggestion.headerTitle,
		title: homeAddressUpdateModalContent.addressSuggestion.title,
		description: homeAddressUpdateModalContent.addressSuggestion.description,
		variant: 'warning',
		primaryAction: homeAddressUpdateModalContent.addressSuggestion.primaryAction,
		secondaryAction: homeAddressUpdateModalContent.addressSuggestion.secondaryAction,
	},
};

export {
	AddressUpdateStatusEnum,
	AddressValidationReasonEnum,
	addressStatusToModalMode,
	homeAddressUpdateModalByMode,
};
